export default __webpack_public_path__ + "static/media/CoinGrey.d5b60011.svg";